import * as React from 'react';

function SvgIconAccept(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 .875a6.125 6.125 0 100 12.25A6.125 6.125 0 007 .876zM9.646 5l-2.88 3.992a.435.435 0 01-.707 0L4.354 6.629a.11.11 0 01.09-.173h.64c.14 0 .273.067.355.182l.973 1.35 2.15-2.98a.437.437 0 01.353-.182h.642c.089 0 .14.101.089.174z"
        fill="#3BC56F"
      />
    </svg>
  );
}

export default SvgIconAccept;
